
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0218 21H3.81818C3.33597 21 2.87351 20.8104 2.53253 20.4728C2.19156 20.1352 2 19.6774 2 19.2V10.8V4C2 3.44771 2.44772 3 3 3H8.64338C9.02803 3 9.37858 3.22062 9.54497 3.56742L10.7278 6.03258C10.8941 6.37938 11.2447 6.6 11.6293 6.6H21C21.5523 6.6 22 7.04771 22 7.6V12.8096C20.8321 11.6888 19.2465 11 17.5 11C13.9101 11 11 13.9101 11 17.5C11 18.7886 11.375 19.9897 12.0218 21Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M20.125 15.75C20.6082 15.75 21 15.3582 21 14.875C21 14.3918 20.6082 14 20.125 14C19.8011 14 19.5184 14.176 19.3671 14.4375H16.625C15.4169 14.4375 14.4375 15.4169 14.4375 16.625C14.4375 17.8331 15.4169 18.8125 16.625 18.8125H16.7421C16.8934 19.074 17.1761 19.25 17.5 19.25C17.8239 19.25 18.1066 19.074 18.2579 18.8125H18.375C19.0999 18.8125 19.6875 19.4001 19.6875 20.125C19.6875 20.8499 19.0999 21.4375 18.375 21.4375H15.6329C15.4816 21.176 15.1989 21 14.875 21C14.3918 21 14 21.3918 14 21.875C14 22.3582 14.3918 22.75 14.875 22.75C15.1989 22.75 15.4816 22.574 15.6329 22.3125H18.375C19.5831 22.3125 20.5625 21.3331 20.5625 20.125C20.5625 18.9169 19.5831 17.9375 18.375 17.9375H18.2579C18.1066 17.676 17.8239 17.5 17.5 17.5C17.1761 17.5 16.8934 17.676 16.7421 17.9375H16.625C15.9001 17.9375 15.3125 17.3499 15.3125 16.625C15.3125 15.9001 15.9001 15.3125 16.625 15.3125H19.3671C19.5184 15.574 19.8011 15.75 20.125 15.75Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowSubprocessFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
